<template>
  <div class="designations">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Designations</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Designations</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn ml-1">
                  <i class="fa fa-plus"></i> Add Designation
                </a>
                <a @click="openDialogImport" class="btn add-btn">
                  <i class="fa fa-plus"></i> Import Designation
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterDesignation"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Designation</label>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="searchDesignation"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditDesignation(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteDesignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
                <!-- <template v-slot:[`item.profile`]="{ item }">
        <h2 class="table-avatar blue-link">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="../assets/profiles/avatar-02.jpg"
                          /></router-link>
                          <router-link to="/profile">{{
                            `${item.firstName}`
                          }}</router-link>
                        </h2>
      </template> -->

                <!-- <table class="table table-striped custom-table mb-0 datatable">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Designation </th>
                      <th>Department </th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in designations" v-bind:key="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.department.name}}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="setEditDesignation(item)" data-toggle="modal" data-target="#edit_designation"><i
                                class="fa fa-pencil m-r-5"></i> Edit</a>
                            <a class="dropdown-item" @click="setDesignation(item)" data-toggle="modal" data-target="#delete_designation"><i
                                class="fa fa-trash-o m-r-5"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>







                  </tbody>
                </table> -->
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
        <!-- Add Designation Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Designation</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    v-if="message"
                  >
                    <strong>Success!</strong> {{ message }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Designation Name <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    v-model.trim="$v.name.$model"
                    id="name"
                    name="name"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.name.required"
                    class="invalid-feedback"
                  >
                    Designation Name is required
                  </div>
                  <!-- <input class="form-control" type="text"> -->
                </div>
                <div class="form-group">
                  <label>Department <span class="text-danger">*</span></label>

                  <multiselectvue
                    class="from-control"
                    v-model="selectDeparment"
                    placeholder="Select Department"
                    :custom-label="nameOfRank"
                    :options="departments"
                    :searchable="true"
                    @select="optionSelectRank"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{
                      option.name
                    }}</template>
                  </multiselectvue>

                  <div
                    v-if="submitted && !$v.department.required"
                    class="invalid-feedback"
                  >
                    Department is required
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Designation Modal -->
        <!-- Edit Designation Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Designation</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >Designation Name <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    v-model="designation.name"
                    id="name"
                    name="name"
                    class="form-control"
                  />
                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>

                <div class="form-group">
                  <label>Department <span class="text-danger">*</span></label>

                  <multiselectvue
                    class="from-control"
                    v-model="selectDeparment.id"
                    placeholder="Select Department"
                    :custom-label="nameOfRank"
                    :options="departments"
                    :searchable="true"
                    @select="optionSelectRank"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">{{
                      option.name
                    }}</template>
                  </multiselectvue>

                  <div
                    v-if="submitted && !$v.department.required"
                    class="invalid-feedback"
                  >
                    Department is required
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateDesignation"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Designation Modal -->
        <!-- Delete Designation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Designation</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteDesignation"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Designation Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Designation</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Designation</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Department No</strong> column you are
                    expected to get the value from their representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importDesignation"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      headers: [
        { text: "Designation", value: "name" },
        { text: "Department", value: "department.name" },
        {
          text: "Status",
          align: "start",
          value: "stat",
          sortable: false
        },
        { text: "", value: "actions", sortable: false }
      ],
      filterDesignation: "",
      name: "",
      designations: [],
      designation: {},
      departments: [],
      selectDeparment: "",
      department: null,
      submitted: false,
      loading: false,
      error: "",
      message: "",
      file: null,
      fileName: ""
    };
  },


  validations: {
    name: { required },
    department: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  computed: {
    searchDesignation: function() {
      return this.designations.filter(
        d =>
          d.name.toLowerCase().includes(this.filterDesignation.toLowerCase()) ||
          d.department.name
            .toLowerCase()
            .includes(this.filterDesignation.toLowerCase())
      );
    }
  },

  methods: {
    nameOfRank({ name }) {
      return `${name}`;
    },

    optionSelectRank(option, id) {
      console.log(option.id);
      this.department = option.id;
    },

    openDialog() {
      this.dialog = true;
    },
    openDialogImport() {
      this.dialogImport = true;
    },
    clearModel() {
      this.name = "";
      this.department = "";
      this.selectDeparment = "";
      this.error = "";
      this.message = "";
      this.submitted = false
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEditDesignation(model) {
      this.designation = model;
      this.dialogEdit = true;
    },
    setDeleteDesignation(model) {
      this.designation = model;
      this.dialogDelete = true;
    },
    getDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
          // console.log(model);

        },
        error => {
          error = error;
        }
      );
    },
    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    setDesignation(item) {
      this.designation = item;
    },
    updateDesignation() {
      this.submitted = true;

      this.loading = true;
      //console.log('department updated 1')
      organizationService
        .updateDesignation(
          this.designation.id,
          (this.designation.departmentId = this.selectDeparment.id),
          this.designation.name,
          console.log('designation', designation.departmentId)

        )
        .then(
          id => {
            organizationService.getDesignations().then(o => {
              this.designations = o;
              this.closeEdit();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    downloadTemplate() {
      organizationService.downloadDesignationTemplate().then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    deleteDesignation() {
      const id = this.designation.id;
      organizationService.removeDesignation(id).then(
        id => {
          organizationService.getDesignations().then(o => {
            this.designations = o;
            this.dialogDelete = false;
          });
        },
        e => {
          this.error = "Designation being used in some information";
          this.dialogDelete = false;
        }
      );
    },
    importDesignation() {
      organizationService.importDesignation(this.file).then(
        response => {
          organizationService.getDesignations().then(o => {
            (this.designations = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // }

      this.loading = true;

      organizationService.addDesignation(this.name, this.department).then(
        id => {
          //console.log(this.name, this.department)
          this.message = "Designation added Successfully";
          organizationService.getDesignations().then(o => {
            this.designations = o;
          });
          this.close();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getDepartments();
    this.getDesignations();

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "companydesignations"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/companydesignations.vue